// Public entry point for the Butterfly SDK.
// Games import { createSDK } and never touch the internals directly.

import { ButterflyGamesSDK } from './core/sdk.js';

export function createSDK(config) {
  return new ButterflyGamesSDK(config);
}

export { ButterflyGamesSDK };
export { DEFAULT_CONFIG } from './core/config.js';
export { loadButterflySDK } from './loader.js';
